import React from "react";
import Hero from "../sections/Hero";
import AboutPremium from "../sections/AboutPremium";
import ServicesPremium from "../sections/ServicesPremium";
import TeamPremium from "../sections/TeamPremium";
import TestimonialsPremium from "../sections/TestimonialsPremium";
import ContactPremium from "../sections/ContactPremium";

const HomePage = () => {
  return (
    <main>
      <Hero />
      <AboutPremium />
      <ServicesPremium />
      <TeamPremium />
      <TestimonialsPremium />
      <ContactPremium />
    </main>
  );
};

export default HomePage;
